module.exports = __webpack_public_path__ + "img/footprint_violent_violet.c28591d7.png";